module.exports = __webpack_public_path__ + "static/media/spacehack.7537d434.png";